module.exports = __webpack_public_path__ + "static/media/table.0c37f441.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/think/table.jpg
// module id = 171
// module chunks = 0